import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { appRoutesDev, appRoutesProd } from './app.routing';
import { AppComponent } from './app.component';
import { MixpanelModule } from './shared/misc/analytics/mixpanel.module';
import * as Sentry from '@sentry/angular';
import { OrigamiApiModule } from './origami-api/origami-api.module';
import { Router, RouterModule, UrlSerializer } from '@angular/router';
import { SessionModule } from './session/session.module';
import { TiLayoutModule } from '@app/extensions/kendo/kendo-angular-layout/ti.layout.module';
import { UploadInterceptorService, UrlSerializerService } from '@app/services';
import { AppService } from '@app/app.service';
import { GlobalEventService } from '@app/services/global-event.service';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { AuthSharedModule } from './pages/auth/auth-shared.module';
import { environment } from '../environments/environment';
import { ConfidentialityAgreementModule } from './shared/misc/confidentiality-agreement/confidentiality-agreement.module';
import { InstancesManagerService } from '@app/services/instances-manager.service';
import { TypifiedModalModule } from '@app/shared/dialogs/typified-modal/typified-modal.module';
import { MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ICON_SETTINGS, IconSettingsService } from '@progress/kendo-angular-icons';
import { TiIconSettingsService } from '@app/extensions/kendo/kendo-icon-settings.service';
import { appConfig } from './app.config';

const routes = environment.production ? appRoutesProd : appRoutesDev;

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    TiLayoutModule,
    ConfidentialityAgreementModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      enableTracing: false,
    }),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    OrigamiApiModule.forRoot(),
    MixpanelModule.forRoot(),
    SessionModule.forRoot(),
    BrowserAnimationsModule,
    ModalModule,
    TypifiedModalModule,
    AuthSharedModule,
    MultiSelectModule,
    ButtonModule,
  ],
  providers: [
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    { provide: IconSettingsService, useClass: TiIconSettingsService },
    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptorService, multi: true },
    { provide: UrlSerializer, useClass: UrlSerializerService },
    AppService,
    GlobalEventService,
    InstancesManagerService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    ...appConfig.providers,
  ],
})
export class AppModule {}
